import React, { useState, useEffect } from 'react'
import { ContentWrapper } from './Style'
import AssessmentContainer from './Partials/AssessmentContainer'
import CommunicationInstructions from './Partials/Communicationassmt/instruction'
import BehaviourInstructions from './Partials/Behaviourassmt/instruction'
import { useSelector } from 'react-redux'

const Assessment = ({
  questions,
  totalQuestions,
  loading,
  error,
  responses,
  fetchAssessmentQuestions,
  saveQuestionResponse,
  activeAssessments,
  activeAssessmentsLoading,
  activeAssessmentsError,
  activeAssessmentsFilters,
  completedAssessments,
  completedAssessmentsLoading,
  completedAssessmentsError,
  completedAssessmentsFilters,
  fetchActiveAssessments,
  fetchCompletedAssessments,
  setActiveAssessmentFilters,
  setCompletedAssessmentFilters,
  setCurrentAssessmentId,
  fetchCommunicationInstructions,
}) => {
  const [assessment, setAssessment] = useState(null)
  const { studentDetails } = useSelector(state => state?.studentData)
  const studentId = studentDetails?.id

  if (assessment) {
    if (assessment.type === 'Behavior') {
      return (
        <BehaviourInstructions
          assessment={assessment}
          questions={questions}
          totalQuestions={totalQuestions}
          loading={loading}
          error={error}
          responses={responses}
          fetchAssessmentQuestions={fetchAssessmentQuestions}
          saveQuestionResponse={saveQuestionResponse}
          studentId={studentId}
          setAssessment={setAssessment}
        />
      )
    }
    if (assessment.type === 'Communication') {
      return (
        <CommunicationInstructions
          assessment={assessment}
          questions={questions}
          totalQuestions={totalQuestions}
          loading={loading}
          error={error}
          responses={responses}
          fetchCommunicationInstructions={fetchCommunicationInstructions}
          fetchAssessmentQuestions={fetchAssessmentQuestions}
          saveQuestionResponse={saveQuestionResponse}
          studentId={studentId}
          setAssessment={setAssessment}
        />
      )
    }
  }

  return (
    <ContentWrapper>
      <AssessmentContainer
        loading={loading}
        error={error}
        setAssessment={setAssessment}
        activeAssessments={activeAssessments}
        activeAssessmentsLoading={activeAssessmentsLoading}
        activeAssessmentsError={activeAssessmentsError}
        activeAssessmentsFilters={activeAssessmentsFilters}
        completedAssessments={completedAssessments}
        completedAssessmentsLoading={completedAssessmentsLoading}
        completedAssessmentsError={completedAssessmentsError}
        completedAssessmentsFilters={completedAssessmentsFilters}
        fetchActiveAssessments={fetchActiveAssessments}
        fetchCompletedAssessments={fetchCompletedAssessments}
        setActiveAssessmentFilters={setActiveAssessmentFilters}
        setCompletedAssessmentFilters={setCompletedAssessmentFilters}
        studentId={studentId}
        setCurrentAssessmentId={setCurrentAssessmentId}
      />
    </ContentWrapper>
  )
}

export default Assessment
